import { User } from '@auth/user';
import UserModel from '@auth/user/models/UserModel';
import { PartialDeep } from 'type-fest';
import apiFetch from '@/utils/apiFetch';

/**
 * Get user by id
 * TODO: Update with actual Laravel endpoint
 */
export async function authGetDbUser(userId: string): Promise<Response> {
	return apiFetch(`user/${userId}`);
}

/**
 * Get user by email
 * TODO: Update with actual Laravel endpoint
 */
export async function authGetDbUserByEmail(email: string): Promise<Response> {
	return apiFetch(`user-by-email/${email}`);
}

/**
 * Update user
 * TODO: Update with actual Laravel endpoint
 */
export function authUpdateDbUser(user: PartialDeep<User>) {
	return apiFetch(`user/${user.id}`, {
		method: 'PUT',
		body: JSON.stringify(UserModel(user))
	});
}

/**
 * Create user
 * TODO: Update with actual Laravel endpoint
 */
export async function authCreateDbUser(user: PartialDeep<User>) {
	return apiFetch('users', {
		method: 'POST',
		body: JSON.stringify(UserModel(user))
	});
}
